import {
    ChangeDetectionStrategy,
    Component,
    inject,
    OnInit,
} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LayoutComponent } from "./modules/layout/layout.component";
import packageJson from "../../package.json";
import { AuthService } from "./services/auth.service";
import { DictionaryFacade } from "./store/facade/dictionary.facade";

@Component({
    standalone: true,
    selector: "gwo-root",
    imports: [RouterOutlet, LayoutComponent],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    readonly dictionaryFacade = inject(DictionaryFacade);

    title = "Edytor publikacji v." + packageJson.version;

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.authService.handleLogin();
        this.dictionaryFacade.getDictionary();
    }
}
